import React from 'react';
import { motion } from 'framer-motion';
import './GalleryAndTestimonials.css';

// Jumbled product images (placeholders)
import bulkSnacks from '../../assets/snacks.jpg'; // Crisps and nuts
// import cannedGoods from '../../assets/canned-goods.jpg'; // Tinned veg and fish
// import cleaningSupplies from '../../assets/cleaning-supplies.jpg'; // Detergents and wipes
import softDrinks from '../../assets/cola.jpg'; // Cola and juice
import toiletries from '../../assets/shampoo.jpg'; // Shampoo and soap

const GalleryAndTestimonials = () => {
  return (
    <section className="gallery-testimonial-section">
      <div className="gallery-testimonial-container">
        {/* Gallery Section */}
        <div className="gallery">
          <motion.h2
            className="gallery-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            Our Bulk Bonanza
          </motion.h2>
          <div className="gallery-grid">
            <motion.div
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <img src={softDrinks} alt="Soft Drinks" />
              <span className="gallery-caption">Fizzy Drinks Galore</span>
            </motion.div>
            {/* <motion.div
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true }}
            >
              <img src={cleaningSupplies || ""} alt="Cleaning Supplies" />
              <span className="gallery-caption">Wipe Out Dirt Cheap</span>
            </motion.div> */}
            <motion.div
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <img src={bulkSnacks} alt="Bulk Snacks" />
              <span className="gallery-caption">Snack Stacks</span>
            </motion.div>
            <motion.div
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              viewport={{ once: true }}
            >
              <img src={toiletries} alt="Toiletries" />
              <span className="gallery-caption">Fresh for Less</span>
            </motion.div>
            {/* <motion.div
              className="gallery-item"
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <img src={cannedGoods} alt="Canned Goods" />
              <span className="gallery-caption">Tin-Tastic Deals</span>
            </motion.div> */}
          </div>
        </div>

        {/* Testimonial Section */}
        <div className="testimonials">
          <motion.h2
            className="testimonial-title"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            Traders Talk
          </motion.h2>
          <div className="testimonial-grid">
            <motion.div
              className="testimonial-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
            >
              <p className="testimonial-quote">
                VBC’s bulk drinks are a game-changer for my corner shop. Delivery’s quick, and the prices let me undercut the big chains!
              </p>
              <p className="testimonial-author">Ravi Patel</p>
              <p className="testimonial-role">Shop Owner, East London</p>
            </motion.div>
            <motion.div
              className="testimonial-card"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <p className="testimonial-quote">
                Stocked up on cleaning gear for my catering gig—top quality, and the savings mean more profit on every event.
              </p>
              <p className="testimonial-author">Lisa Murray</p>
              <p className="testimonial-role">Caterer, Manchester</p>
            </motion.div>
            <motion.div
              className="testimonial-card"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: 0.4 }}
              viewport={{ once: true }}
            >
              <p className="testimonial-quote">
                Best place for bulk snacks—my market stall’s never been busier. VBC’s got the variety traders need.
              </p>
              <p className="testimonial-author">Jamal Khan</p>
              <p className="testimonial-role">Market Vendor, Birmingham</p>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GalleryAndTestimonials;